<template>
  <main>
    <div class="container-fluid pt-3">

      <div class="card shadow-lg ">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{id}}</h5>
                <p class="mb-0 font-weight-bold text-sm">{{site}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12 mb-4">
          <div class="card card-plain border border-primary">
            <div class="card-header text-start bg-primary">
              <div class="d-flex align-items-center">
                <p class="text-uppercase text-sm text-white">유저정보</p>
                <!-- <button type="button"  class="btn btn-sm mb-0 ms-auto btn-info">
                  수정
                </button> -->
              </div>
            </div>
            <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">


              <div class="row">
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">아이디</label>
                  <input class="form-control" type="text" v-model="id" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">이메일</label>
                  <input class="form-control" type="text" v-model="email" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">이름</label>
                  <input class="form-control" type="text" v-model="name" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">추천인</label>
                  <input class="form-control" type="text" v-model="reffer" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">후원인</label>
                  <input class="form-control" type="text" v-model="support" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">직급</label>
                  <input class="form-control" type="text" :value="CheckGrade(grade)" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">추천코드</label>
                  <input class="form-control" type="text" v-model="code" readonly />
                </div>
                <div class="col-12 col-xl-6">
                  <label for="example-text-input" class="form-control-label">상태</label>
                  <input class="form-control" type="text" :value="CheckStatus(status)" readonly />
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-xl-6 mt-2 mb-2">
                  <label for="example-text-input" class="form-control-label">구독</label>
                  <div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="is_subscribe" @change="ToggleSubscribe">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-xl-6 mt-2">
                  <button type="button" class="btn btn-primary" @click="ResetPassword()" >비밀번호 초기화</button>
                  <button type="button" class="btn btn-success mx-2" data-bs-toggle="modal" data-bs-target="#edit_member" @click="EditInfo()">고객 정보 수정</button>
                  <button type="button" class="btn btn-info" @click="ResetSupport()" >후원인 초기화</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6  mb-4">
          <div class="card card-plain border border-success">
            <div class="card-header text-start bg-success">
              <div class="d-flex align-items-center">
                <p class="text-uppercase text-sm text-white">지갑 정보</p>
              </div>
            </div>
            <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">
              <div class="row">
                <div class="col-12 col-xl-12">
                  <label for="example-text-input" class="form-control-label">지갑주소</label>
                  <input class="form-control" type="text" v-model="address" readonly />
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xl-4">
                  <label for="example-text-input" class="form-control-label">TRON 보유금액</label>
                  <input class="form-control" type="text" v-model="tron_balance" readonly />
                </div>
                <div class="col-12 col-xl-4">
                  <label for="example-text-input" class="form-control-label">USDT 보유금액</label>
                  <input class="form-control" type="text" v-model="usdt_balance" readonly />
                </div>
                <div class="col-12 col-xl-4">
                  <label for="example-text-input" class="form-control-label">MCS 보유금액</label>
                  <input class="form-control" type="text" v-model="mcs_balance" readonly />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6  mb-4">
          <div class="card card-plain border border-success">
            <div class="card-header text-start bg-success">
              <div class="d-flex align-items-center">
                <p class="text-uppercase text-sm text-white">지갑 히스토리</p>
              </div>
            </div>
            <div class="card-body bg-white" style="border-bottom-left-radius: 1rem;border-bottom-right-radius: 1rem;">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">TRON</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">USDT</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#mcs-history" role="tab" aria-controls="profile" aria-selected="false">MCS</a>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  <TRON></TRON>
                </div>
                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                  <USDT></USDT>
                </div>
                <div class="tab-pane fade" id="mcs-history" role="tabpanel" aria-labelledby="profile-tab">
                  <MCS></MCS>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6  mb-4">
          <Sales></Sales>
        </div>

        <div class="col-md-6  mb-4">
          <Extra></Extra>
        </div>
      </div>
    </div>


    <div class="modal" tabindex="-1" id="edit_member">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">고객 정보 수정</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">고객명</label>
            <input type="type" class="form-control" v-model="edit_name" placeholder="고객명을 입력해주세요." />
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">이메일</label>
            <input type="type" class="form-control" v-model="edit_email" placeholder="이메일을 입력해주세요." />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="EditMember()">수정</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapMutations } from "vuex";
const exactMath = require('exact-math');
const CryptoJS = require("crypto-js");
import Sales from '@/components/Member/DetailSales.vue';
import Extra from "@/components/Member/DetailExtra.vue";
import {Modal} from 'bootstrap';

import TRON from '@/components/Member/DetailTRON.vue';
import USDT from "@/components/Member/DetailUSDT.vue";
import MCS from "@/components/Member/DetailMCS.vue";

export default {
  name: "profile",
  components: {
    Sales,Extra,TRON,USDT, MCS

  },
  data() {
    return {
      showMenu: false,
      no :this.$route.params.no,
      id : '',
      email : '',
      reffer : '',
      name : '',
      code : '',
      status : '',
      type : '',
      grade : '',
      plan : '',
      is_subscribe: false,
      tron_balance:'',
      usdt_balance:'',
      mcs_balance:'',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
      EditModel : '',
      edit_name:'',
      edit_email:'',
    };
  },


  mounted() {
    this.EditModel = new Modal(document.getElementById('edit_member'));
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.isAbsolute = false;
    this.GetMemberDetail();
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      }
    }

  },
  methods:{
    EditInfo(){
      this.edit_name = this.name;
      this.edit_email = this.email;
    },
    comma(str) {
     str = String(str);
     return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    },
    ...mapMutations(["navbarMinimize"]),
    onCopy(e){
      this.$alert.alert(e.text);
    },
    CheckStatus(status){
      if(status=='Y'){
        return '접속가능'
      }else if(status=='C'){
        return '차단'
      }else if(status=='B'){
        return '접속불가'
      }else if(status=='H'){
        return '인증대기'
      }

    },
    CheckGrade(type){
      if(type =='0'){
        return '일반'
      }else if(type=='1'){
        return '프로'
      }else if(type=='2'){
        return '빌더'
      }else if(type=='3'){
        return '마스터'
      }else if(type=='4'){
        return '브론즈 마스터'
      }else if(type=='5'){
        return '실버 마스터'
      }else if(type=='6'){
        return '골드 마스터'
      }else if(type=='7'){
        return '블랙 마스터'
      }
    },
    CheckPlan(type){
      if(type =='0'){
        return '미 구독'
      }else if(type=='1'){
        return 'PLAN 1'
      }else if(type=='2'){
        return 'PLAN 2'
      }else if(type=='3'){
        return 'PLAN 3'
      }
    },
    CheckStatusClass (status){
      if(status=='Y'){
        return 'bg-gradient-success'
      }else if(status=='C'){
        return 'bg-gradient-danger'
      }else if(status=='H'){
        return 'bg-gradient-warning'
      }

    },
    EditMember(){
      const code= this.no;
      const name = this.edit_name;
      const email = this.edit_email;

      const body = {code,name,email};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/member/EditMember', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("정보를 수정하였습니다.").then(
                ()=>{
                  this.$router.go()
                }
              )
            }
          }
        }
      )
    },
    GetMemberDetail(){
      const code= this.no;
      const body = {code};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/member/GetInfo', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              const info  = body.info;
              const wallet  = body.wallet;

              this.id = info.id;
              this.email = info.email;
              this.name = info.name;
              this.reffer = info.reffer;
              this.support = info.support;
              this.code = info.code;
              this.status = info.status;
              this.type = info.type;
              this.grade = info.grade;
              // this.plan = info.plan;
              this.is_subscribe = info.is_subscribe === 1

              this.address = wallet.address;
              this.tron_balance = wallet.balance;

              this.usdt_balance = body.usdt_balance;
              this.mcs_balance = body.mcs_balance;

            }else if(res.data.code=='100'){
              this.$alert.alert("접속경로를 확인해주세요.").then(
                ()=>{
                  this.$router.go(-1);
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    GetHistoryList(){
      const mem_no= this.no;
      const limit = this.limit;
      const page = this.page;

      this.axios.post('/admin/member/GetHistory', {mem_no,page,limit}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.history = res.data.list;
              this.max_page = res.data.count;

            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    ResetSupport(){
      const code= this.no;
      const body = {code};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/member/ResetSupport', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("후원인을 초기화했습니다. 추천인이 직접 후원인을 매칭하시면 됩니다.").then(
                ()=>{
                  this.$router.go()
                }
              )
            }else if(res.data.code=='100'){
              this.$alert.alert("매출이 있습니다.").then(
                ()=>{
                  this.$router.go()
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    ResetPassword(){
      const code= this.no;
      const body = {code};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/member/ResetPassword', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("비밀번호를 초기화했습니다. 초기화 비밀번호는 고객 이메일로 전송하였습니다.").then(
                ()=>{
                  this.$router.go()
                }
              )
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    ToggleSubscribe () {
      const body = {
        id: this.id,
        is_subscribe: this.is_subscribe
      }

      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/member/ChangeSubscribeStatus', {req}).then(
          res => {
            if(res.status ==200){
              if(res.data.code=='200'){
                this.$alert.alert("구독 상태를 변경했습니다.").then(
                    ()=>{
                      this.$router.go()
                    }
                )
              }else if(res.data.code=='9999'){
                this.$store.dispatch('SETLOGOUT').then(
                    ()=>{
                      window.location.href="/login";
                    }
                )
              }
            }
          }
      )
    },
    ClickPaging(i){
      this.page =i;
      this.GetHistoryList();
    },
    CheckPage(i){

      const show = this.show;
      const page = this.page;
      var add_class ='';
      if((i+2) == show){
        if(page ==i){
          add_class = " active ";
        }

      }else if((i+1) == show){
        if(page ==i){
          add_class = " active ";
        }

      }else if((i) == show){
        if(page ==i){
          add_class = " active ";
        }

      }else if((i-1) == show){
        if(page ==i){
          add_class = " active ";
        }

      }else if((i-2) == show){
        if(page ==i){
          add_class = " active ";
        }
      }else{
        add_class += 'd-none';
      }


      return add_class;

    },
    PrevPage(){
      const show = this.show;
      const show_prev = exactMath.sub(show,1);

      if(show_prev >= 3){
        this.show = show_prev;
      }else{
        this.show = show;
      }
    },
    NextPage(){
      const show = this.show;
      const show_next = exactMath.add(show,1);
      const max = exactMath.sub(this.max_page,2);

      if(show_next <= max){
        this.show = show_next;
      }else{
        this.show = max;
      }
    },
  }
};
</script>
